
export const PLAY = 'SLIDESHOW_PLAY';

export const PAUSE = 'SLIDESHOW_PAUSE';

export const SET_IS_PLAYING = 'SET_IS_PLAYING';

export const NEXT_IMAGE = 'SLIDESHOW_NEXT_IMAGE';

export const PREVIOUS_IMAGE = 'SLIDESHOW_PREVIOUS_IMAGE';

export const SET_INDEX = 'SLIDESHOW_SET_INDEX';

export const ADD_IMAGE = 'SLIDESHOW_ADD_IMAGE';

export const SET_DELAY = 'SLIDESHOW_SET_DELAY';



// WEBPACK FOOTER //
// src/actions/slideshowActionTypes.js